import React from 'react'
import { Column } from 'primereact/column'
import { FilterMatchMode } from 'primereact/api'
import MembershipTypeFilterTemplate from '../Filters/MembershipTypeFilterTemplate'
import { createFieldChangedChecker } from '../utils/createFieldChangedChecker'

/**
 * Membership Type column component with automatic membership type dropdown filter
 * @param {string} title - Column header title
 * @param {string} mapsToField - Field name in data
 * @param {boolean} filter - Enable filtering
 * @param {boolean} sortable - Enable sorting
 * @param {boolean} editable - Enable editing
 * @param {Function} isFieldChanged - Function to check if field changed
 * @param {Function} isFieldChangedOverride - Override for field change checker
 * @param {Object} validationErrors - Validation errors object
 * @param {Function} template - Custom display template
 * @param {Object} originalData - Original data for comparison
 * @param {Object} style - Column style
 */
const MembershipTypeColumn = ({ 
    title, 
    mapsToField, 
    filter, 
    sortable, 
    editable, 
    isFieldChanged, 
    isFieldChangedOverride, 
    validationErrors, 
    template, 
    originalData,
    style
}) => {

    const filterAttributes = filter ? {
        filter: true,
        showFilterMenu: true,
        filterElement: (options) => <MembershipTypeFilterTemplate options={options} />,
        filterMatchMode: FilterMatchMode.CONTAINS,
        showFilterMatchModes: false
    } : {}


    const sortAttributes = {
        sortable,
        required: !!sortable,
        disabled: !sortable
    }

    // Create smart field changed checker
    const checkFieldChanged = createFieldChangedChecker({
        editable,
        isFieldChangedOverride,
        defaultIsFieldChanged: isFieldChanged,
        mapsToField,
        originalData
    })

    return (
        <Column
            {...sortAttributes}
            key={mapsToField}
            field={mapsToField}
            header={title}
            style={style}
            body={(rowData) => (
                <span className={`${checkFieldChanged(rowData) ? 'changed-field' : ''} ${rowData.isDeleted ? 'pending-deletion' : ''}`}>
                    {template ? template(rowData) : rowData[mapsToField]}
                </span>
            )}
            {...filterAttributes}
        />
    )
}

export default MembershipTypeColumn
